"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateList = exports.setSwitchDetails = exports.setOfferToSwitch = exports.selectSwitchSettings = exports.selectSwitchDetails = exports.selectPlanDetails = exports.selectCurrentPlanDetails = exports.selectCurrentPlan = exports.resetOfferToSwitch = exports.planDetailsSlice = exports.fetchPendingSwitches = exports.fetchCustomerOffers = exports.fetchAvailableSwitches = exports.default = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _api = require("../api");
const initialState = {
  currentPlan: {
    data: [],
    loading: false,
    error: null
  },
  offerToSwitch: {},
  updateList: false,
  switchSettings: {
    data: {},
    loading: false,
    error: null
  },
  switchDetails: {
    data: {},
    loading: false,
    error: null
  }
};
const fetchCustomerOffers = exports.fetchCustomerOffers = (0, _toolkit.createAsyncThunk)('plan/fetchCustomerOffers', async (_, _ref) => {
  let {
    rejectWithValue
  } = _ref;
  try {
    const {
      items
    } = await (0, _api.getCustomerOffers)();
    return items;
  } catch (err) {
    const typedError = err;
    return rejectWithValue(typedError.message);
  }
});
const fetchPendingSwitches = exports.fetchPendingSwitches = (0, _toolkit.createAsyncThunk)('plan/fetchPendingSwitches', async (subsWithPendingSwitches, _ref2) => {
  let {
    rejectWithValue
  } = _ref2;
  try {
    const switchesList = await Promise.all(subsWithPendingSwitches.map(async _ref3 => {
      let {
        pendingSwitchId
      } = _ref3;
      const switchDetails = await (0, _api.getSwitch)(pendingSwitchId);
      return switchDetails;
    }));
    const switchesObj = switchesList.reduce((acc, current) => ({
      ...acc,
      [current.id]: current
    }), {});
    return switchesObj;
  } catch (err) {
    const typedError = err;
    return rejectWithValue(typedError.message);
  }
});
const fetchAvailableSwitches = exports.fetchAvailableSwitches = (0, _toolkit.createAsyncThunk)('plan/fetchAvailableSwitches', async (subscriptions, _ref4) => {
  let {
    rejectWithValue
  } = _ref4;
  try {
    const availableSwitchesList = await Promise.all(subscriptions.map(async _ref5 => {
      let {
        offerId
      } = _ref5;
      const switches = await (0, _api.getAvailableSwitches)(offerId);
      return {
        offerId,
        switches
      };
    }));
    const availableSwitchesObj = availableSwitchesList.reduce((acc, current) => ({
      ...acc,
      [current.offerId]: current.switches
    }), {});
    return availableSwitchesObj;
  } catch (err) {
    const typedError = err;
    return rejectWithValue(typedError.message);
  }
});
const planDetailsSlice = exports.planDetailsSlice = (0, _toolkit.createSlice)({
  name: 'plan',
  initialState,
  reducers: {
    setOfferToSwitch(state, _ref6) {
      let {
        payload
      } = _ref6;
      state.offerToSwitch = payload;
    },
    resetOfferToSwitch(state) {
      state.offerToSwitch = initialState.offerToSwitch;
    },
    updateList(state) {
      state.updateList = !state.updateList;
    },
    setSwitchDetails(state, _ref7) {
      let {
        payload
      } = _ref7;
      const {
        details,
        type
      } = payload;
      if (type === 'delete') {
        delete state.switchDetails.data[details.pendingSwitchId];
      } else {
        state.switchDetails.data = Object.assign(state.switchDetails.data, details);
      }
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchCustomerOffers.pending, state => {
      state.currentPlan.loading = true;
    });
    builder.addCase(fetchCustomerOffers.fulfilled, (state, action) => {
      state.currentPlan.loading = false;
      state.currentPlan.data = action.payload;
    });
    builder.addCase(fetchCustomerOffers.rejected, (state, action) => {
      state.currentPlan.loading = false;
      state.currentPlan.error = action.payload;
    });
    builder.addCase(fetchPendingSwitches.pending, state => {
      state.switchDetails.loading = true;
    });
    builder.addCase(fetchPendingSwitches.fulfilled, (state, action) => {
      state.switchDetails.loading = false;
      state.switchDetails.data = action.payload;
    });
    builder.addCase(fetchPendingSwitches.rejected, (state, action) => {
      state.switchDetails.loading = false;
      state.switchDetails.error = action.payload;
    });
    builder.addCase(fetchAvailableSwitches.pending, state => {
      state.switchSettings.loading = true;
    });
    builder.addCase(fetchAvailableSwitches.fulfilled, (state, action) => {
      state.switchSettings.loading = false;
      state.switchSettings.data = action.payload;
    });
    builder.addCase(fetchAvailableSwitches.rejected, (state, action) => {
      state.switchSettings.loading = false;
      state.switchSettings.error = action.payload;
    });
  }
});
const selectPlanDetails = state => state.plan;
exports.selectPlanDetails = selectPlanDetails;
const selectCurrentPlan = state => state.plan.currentPlan;
exports.selectCurrentPlan = selectCurrentPlan;
const selectSwitchSettings = state => state.plan.switchSettings;
exports.selectSwitchSettings = selectSwitchSettings;
const selectSwitchDetails = state => state.plan.switchDetails;
exports.selectSwitchDetails = selectSwitchDetails;
const selectCurrentPlanDetails = state => state.plan.currentPlan;
exports.selectCurrentPlanDetails = selectCurrentPlanDetails;
const {
  setOfferToSwitch,
  resetOfferToSwitch,
  updateList,
  setSwitchDetails
} = planDetailsSlice.actions;
exports.setSwitchDetails = setSwitchDetails;
exports.updateList = updateList;
exports.resetOfferToSwitch = resetOfferToSwitch;
exports.setOfferToSwitch = setOfferToSwitch;
var _default = exports.default = planDetailsSlice.reducer;